export const TextInputTemplate = `{{{input}}}<span class="text-input__error"></span>`;
